import { InvoiceBillingStage } from '../../enums/invoiceBillingStage'

export const isFinalInvoice = (billingStage?: InvoiceBillingStage): boolean =>
  billingStage === InvoiceBillingStage.Final
